import React, {useState, useEffect} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import TopBarAlert from './topBarAlert'
import moment from 'moment-timezone';


const TopBarAlertManager = ({...props}) =>
  {
    const [seconds, setSeconds] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [alertIntervals, setAlertIntervals] = useState([]);
    const [currentAlert, setCurrentAlert] = useState({title:'', time:'', message:''});

    const setupAlerts = () => {
        if(!props.alerts || props.alerts.length == 0) return;

        const now = moment().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
        let newAlertIntervals = [];

        for (const alert of props.alerts) {
            let timeTillAlert = moment(alert.time).diff(moment());
            if(timeTillAlert > 1) //if the alert is in the future, add a timeout for it
                newAlertIntervals.push(setTimeout(()=>setCurrentAlert(alert), timeTillAlert));
        }

        setAlertIntervals(newAlertIntervals);
    }

    useEffect(() => {
        setupAlerts();
    }, [props.alerts]);

    return (
      <TopBarAlert message={currentAlert.message} />
    );
  }

export default TopBarAlertManager;